import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'rcp-skeleton-header',
  template: `
    <div class="rcp-skeleton-header">
      <div class="rcp-skeleton-header-text"></div>
    </div>
  `,
  styleUrls: ['./skeleton.components.scss'],
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SkeletonHeaderComponent {}
